import type { RouteObject } from "src/router";
import type { RoutePreload } from "src/router/route-preloads";
import { lazyNamed, lazyWithRetry } from "src/utils/lazy-named";

const modelsImport = () => import("./models");
export const preloads: RoutePreload[] = [["/models", modelsImport]];

const ModelWrapper = lazyNamed(() => import("./model"), "ModelWrapper");
const ModelDraft = lazyNamed(
  () => import("src/components/models/draft"),
  "ModelDraft",
);
const ModelQueryWrapper = lazyNamed(
  () => import("./model/query"),
  "ModelQueryWrapper",
);
const CloneModel = lazyNamed(() => import("./model/clone"), "CloneModel");
const CreateModel = lazyNamed(() => import("./create-model"), "CreateModel");
const Models = lazyWithRetry(modelsImport);

export const routes: Array<RouteObject> = [
  {
    path: "models",
    spacesAccess: "hidden-from-limited-view",
    element: <Models />,
  },
  {
    path: "models/new",
    spacesAccess: "hidden-from-limited-view",
    element: <CreateModel />,
  },
  {
    path: "models/:model_id/*",
    spacesAccess: "hidden-from-limited-view",
    element: <ModelWrapper />,
  },
  {
    path: "models/:model_id/clone",
    spacesAccess: "hidden-from-limited-view",
    element: <CloneModel />,
  },
  {
    path: "models/:model_id/query",
    spacesAccess: "hidden-from-limited-view",
    element: <ModelQueryWrapper />,
  },
  {
    path: "models/:model_id/draft",
    spacesAccess: "hidden-from-limited-view",
    element: <ModelDraft />,
  },
];
